var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.25,
    stroke: "#A9A9A9",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 37C23.4113 37 22.0156 36.6987 20.8128 36.0962C19.6099 35.4714 18.6681 34.6011 17.9872 33.4854C17.3291 32.3473 17 31.0418 17 29.569V20.364C17 18.9135 17.3291 17.6304 17.9872 16.5146C18.6681 15.3989 19.6099 14.5397 20.8128 13.9372C22.0156 13.3124 23.4113 13 25 13C26.5887 13 27.9844 13.3013 29.1872 13.9038C30.3901 14.5063 31.3206 15.3543 31.9787 16.4477C32.6596 17.5411 33 18.802 33 20.2301C33 20.3417 32.966 20.431 32.8979 20.4979C32.8298 20.5649 32.7504 20.5983 32.6596 20.5983L30.9234 20.6987C30.6965 20.6987 30.583 20.5983 30.583 20.3975V20.2971C30.583 18.7127 30.0723 17.4519 29.0511 16.5146C28.0298 15.5551 26.6794 15.0753 25 15.0753C23.3206 15.0753 21.9702 15.5551 20.9489 16.5146C19.9277 17.4742 19.417 18.735 19.417 20.2971V29.6695C19.417 31.2315 19.9277 32.4923 20.9489 33.4519C21.9702 34.4114 23.3206 34.8912 25 34.8912C26.6794 34.8912 28.0298 34.4226 29.0511 33.4854C30.0723 32.5258 30.583 31.2538 30.583 29.6695V29.6025C30.583 29.4017 30.6965 29.3013 30.9234 29.3013L32.6596 29.4017C32.8865 29.4017 33 29.5021 33 29.7029C33 31.1534 32.6596 32.4365 31.9787 33.5523C31.3206 34.6457 30.3901 35.4937 29.1872 36.0962C27.9844 36.6987 26.5887 37 25 37Z",
    fill: "#A9A9A9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCoin);
export default __webpack_public_path__ + "static/media/empty_coin.968ea183f7c69564a2860046c194d6a6.svg";
export { ForwardRef as ReactComponent };